export default {
  emptyValue: '---',
};
